module.exports = __webpack_public_path__ + "img/VF.c73abe54.png";